<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-link`]" width="1em" height="1em" v-bind="$attrs"><path d="M11.7139 6.0321C11.9736 5.77258 12.3947 5.77255 12.6544 6.0321L13.6397 7.01746C15.464 8.84192 15.446 11.8087 13.627 13.6278C11.8079 15.4465 8.84194 15.4637 7.01764 13.6395L6.43853 13.0604C4.6141 11.236 4.63215 8.2702 6.45123 6.45105C6.71093 6.19142 7.13199 6.19137 7.39166 6.45105C7.65095 6.71076 7.65115 7.1319 7.39166 7.39148C6.08662 8.69657 6.07925 10.8202 7.37896 12.12L7.95807 12.6991C9.25765 13.9985 11.3815 13.992 12.6866 12.6874C13.9915 11.3823 13.9988 9.25762 12.6993 7.95789L11.7139 6.97253C11.4544 6.71283 11.4543 6.29177 11.7139 6.0321ZM2.37213 2.37195C4.19124 0.552876 7.15807 0.535773 8.98248 2.36023L9.56158 2.93933C11.3857 4.76379 11.3678 7.72964 9.54889 9.54871C9.28924 9.80836 8.86816 9.80826 8.60846 9.54871C8.34899 9.28899 8.34884 8.8679 8.60846 8.60828C9.91329 7.30327 9.92057 5.17949 8.62115 3.87976L8.04205 3.30066C6.74235 2.00093 4.61762 2.00737 3.31256 3.31238C2.00751 4.61746 2.00112 6.74212 3.30084 8.04187L4.20318 8.94421C4.46269 9.2039 4.46275 9.62499 4.20318 9.88464C3.94354 10.1443 3.52246 10.1442 3.26275 9.88464L2.36041 8.9823C0.535975 7.15782 0.553038 4.19109 2.37213 2.37195Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineLink',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
